import {applyMiddleware, combineReducers, createStore} from "redux";
import {main_reducer} from "./reducers/main_reducer";
import thunk from "redux-thunk";

const rootReducer = combineReducers({
    main: main_reducer
})

export const store = createStore(rootReducer, applyMiddleware(thunk))